import(/* webpackMode: "eager", webpackExports: ["CatalogBody"] */ "/app/src/modules/Catalog/components/CatalogBody/Mobile/CatalogBody.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["FakeHeader"] */ "/app/src/shared/common/Header/components/FakeHeader/Mobile/FakeHeader.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/views/category/Desktop.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/views/category/Mobile.module.scss");
